/**
 * App bootstrap (frontend-map §6.1 — FOUNDATION-owned).
 * Mounts the typed router. All providers live in __root.tsx so they wrap every
 * route uniformly (Clerk + Query are the ONLY providers — frontend-map §0).
 */
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './router';
import './styles.css';

// Resume where the user left off: an installed PWA always cold-launches at the
// manifest start_url ("/"), so if we saved a deeper route, rewrite the URL before
// the router mounts (no home-screen flash, no redirect).
try {
  const nav = window.navigator as Navigator & { standalone?: boolean };
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches || nav.standalone === true;
  const saved = localStorage.getItem('uc-last-route');
  if (standalone && saved && saved !== '/' && window.location.pathname === '/') {
    window.history.replaceState(null, '', saved);
  }
} catch {
  // localStorage/matchMedia unavailable — just start at the default route.
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
